import { render, staticRenderFns } from "./AddressBookUpdateAddress.vue?vue&type=template&id=9bb9c792&scoped=true&"
import script from "./AddressBookUpdateAddress.vue?vue&type=script&lang=js&"
export * from "./AddressBookUpdateAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb9c792",
  null
  
)

export default component.exports